import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { LoadingWrapper } from 'barnyard/components';
import { localStorageHelper } from '~/accounts/core/utils';
import { buyerFetchFormFields, buyerUpdate, profileFetch } from './actions';
import { getProfile, getBuyer } from './selectors';
import {
  USER_FORM_URL,
  CLINIC_FORM_URL,
  VENDOR_FORM_URL,
  FINISHED_URL
} from './constants';

/*
  Rendered for every component in the Signup app. Will handle the initial fetching of
  profile and necessary form content

  Also will be responsible for redirecting to URLs when necessary
*/

class Root extends Component {
  componentDidMount() {
    const {
      buyerFetchFormFieldsAction,
      profileFetchAction,
    } = this.props;

    profileFetchAction();
    buyerFetchFormFieldsAction();
  }

  componentDidUpdate(prevProps) {
    const { profile: prevProfile, buyer: prevBuyer } = prevProps;
    const {
      profile,
      buyer,
      router,
      location
    } = this.props;

    const wasLoadingProfile = prevProfile.isLoading === true && profile.isLoading === false;
    const wasLoadingBuyer = prevBuyer.isLoading === true && prevBuyer.isLoading === false;
    const hasStoppingQueryParam = location.query.redirect === 'false';

    if (hasStoppingQueryParam || (!wasLoadingProfile && !wasLoadingBuyer)) {
      return;
    }

    if (prevProfile.isError === false && profile.isError === true) {
      return router.replace({
        pathname: USER_FORM_URL,
        search: location.search
      });
    }

    if (profile.isFetched) {
      // If the buyer has not updated their information yet, let's
      // redirect to the clinic portion of signup
      if (!_.isNull(buyer) && !buyer.has_updated_information) {
        return router.replace({
          pathname: CLINIC_FORM_URL,
          search: location.search
        });
      }
      // If the buyer has updated their information yet but hasn't completed
      // signup, let's redirect to the vendor portion of signup
      if (!buyer.has_completed_signup) {
        return router.replace({
          pathname: VENDOR_FORM_URL,
          search: location.search
        });
      }

      localStorageHelper.clear();
      window.location = location.query.next || FINISHED_URL;
    }
  }

  render() {
    const {
      profile,
      buyer,
      location
    } = this.props;

    const isLoading = location.query.redirect !== 'false' && (
      profile.isFetched && !_.isNull(buyer) && buyer.has_updated_information && buyer.has_completed_signup
    );

    return (
      <LoadingWrapper loading={isLoading}>
        {this.props.children}
      </LoadingWrapper>
    );
  }
}

Root.propTypes = {
  children: PropTypes.node.isRequired,
  buyerFetchFormFieldsAction: PropTypes.func.isRequired,
  profileFetchAction: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  buyer: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  buyer: getBuyer(state),
  profile: getProfile(state),
});

const mapDispatchToProps = dispatch => ({
  buyerFetchFormFieldsAction: () => dispatch(buyerFetchFormFields()),
  buyerUpdateAction: (...p) => dispatch(buyerUpdate(...p)),
  profileFetchAction: () => dispatch(profileFetch())
});

export default connect(mapStateToProps, mapDispatchToProps)(Root);
